module.exports = "/images/timeout.svg";